import { GRP_ROLES_HRIN } from "@/lib/grp";
import { functionality } from "@/prisma/generated/enums";

export type RoutePolicy = {
  module: string;
  api?: readonly RegExp[];
  page?: readonly RegExp[];
  roles?: readonly number[];
  functionality?: functionality;
};

export const ROUTE_POLICIES: readonly RoutePolicy[] = [
  {
    module: "Vue Véhicule",
    api: [/^\/api\/hrin\/car-view/],
    page: [/^\/backoffice\/hrin\/car-view/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },
  {
    module: "RCE/CNIT",
    api: [
      /^\/api\/hrin\/homologation/,
      /^\/api\/hrin\/import\/rce/,
      /^\/api\/hrin\/rapprochement/,
    ],
    page: [/^\/backoffice\/hrin\/homologation/],
    functionality: "H",
  },
  {
    module: "FDM (Feuille des Mines)",
    api: [/^\/api\/hrin\/fdm/, /^\/api\/hrin\/document\/fdm/],
    page: [/^\/backoffice\/hrin\/fdm/],
    functionality: "H",
  },

  {
    module: "Déclaration de Livraison",
    api: [/^\/api\/hrin\/delivery/],
    page: [/^\/backoffice\/hrin\/delivery/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },
  {
    module: "Base constructeur",
    api: [/^\/api\/hrin\/base-vin/],
    page: [/^\/backoffice\/hrin\/base-vin/],
    functionality: "H",
  },

  {
    module: "Fin d’Usage Démonstration",
    api: [/^\/api\/hrin\/fud/],
    page: [/^\/backoffice\/hrin\/end-of-use-demonstration/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },
  {
    module: "Données Carte Grise",
    page: [/^\/backoffice\/hrin\/car-certificate/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },

  {
    module: "Immatriculation VN",
    page: [/^\/backoffice\/hrin\/registration/],
    api: [/^\/api\/hrin\/immat/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },
  {
    module: "Agrément / Habilitation",
    page: [/^\/backoffice\/hrin\/agreement/],
    roles: GRP_ROLES_HRIN,
    functionality: "RIN",
  },
] as const;

export function resolvePolicy(path: string): RoutePolicy | null {
  return (
    ROUTE_POLICIES.find((policy) => {
      const apiMatch = policy.api?.some((r) => r.test(path)) ?? false;
      const pageMatch = policy.page?.some((r) => r.test(path)) ?? false;

      return apiMatch || pageMatch;
    }) || null
  );
}
